/* eslint-disable jsx-a11y/alt-text */
import React, { useEffect, useState } from "react";
import ProfileEdit from "../profileEdit/ProfileEdit";
import Bookings from "./Bookings/Bookings";
import axios from "axios";
import { base_url } from "../../../config";
import { Link } from "react-router-dom";

const ProfilePageContent = () => {
  const [selectedTab, setSelectedTab] = useState(0);
  const [userProfile, setUserProfile] = useState();
  const [editProfileClicked, setEditProfileCliked] = useState(false);

  const accessToken = localStorage.getItem("@user");

  const fetchProfileData = async () => {
    try {
      const response = await axios.get(`${base_url}/profile-members/profile`, {
        headers: { authorization: `Bearer ${accessToken}` },
      });

      // console.log("Profile Data:", response.data.data);
      setUserProfile(response.data.data);
    } catch (error) {
      console.error("Failed to fetch profile data:", error);
    }
  };

  useEffect(() => {
    fetchProfileData();
  }, []);

  const interestMapping = {
    30: "Travellers",
    31: "Others",
    33: "Relationships",
    34: "Taboo",
    35: "F&B",
    36: "In the shoes of",
    10: "Books",
  };
  const userInterests = userProfile?.interests || []; // Fallback to an empty array if interests are undefined

  // Get the names of the interests based on the codes
  const interestNames = userInterests
    .map((code) => interestMapping[code])
    .filter(Boolean);

  return (
    <section className="my-account-section">
      <div className="profile-wrapper">
        <div
          id="w-node-_9eedf92e-a962-7390-bcac-0ae6424c1a76-27b28b52"
          className="profile-card-left"
        >
          <div className="profile-card-wrapper">
            <div className="review_details-left-item">
              <div className="review_details-flex-item">
                <div className="review-five-user">
                  {userProfile?.photo ? (
                    <img
                      className="user-profile-pic"
                      src={userProfile?.photo}
                    />
                  ) : (
                    <div className="nav-icon">
                      <div className="user" />
                    </div>
                  )}
                </div>
                <div className="review_details-content">
                  <div className="margin-bottom margin-xxsmall">
                    <h6 className="heading-6">{userProfile?.first_name}</h6>
                  </div>
                  <div className="margin-bottom">
                    <div className="date-text">
                      {userProfile?.gender && <>{userProfile?.gender}</>}
                      {/* {userProfile?.age && <>{userProfile?.age}</>} Years Old */}
                    </div>
                  </div>
                </div>
              </div>

              <div className="profile-card-rating-flex">
                <div
                  data-w-id="01dae784-a55a-5e0e-b540-62dcbf1303a9"
                  style={{
                    opacity: 1,
                  }}
                  className="review-block-big"
                >
                  <div className="code-embed-7 w-embed">
                    {/*?xml version="1.0" encoding="utf-8"?*/}
                    {/*  Uploaded to: SVG Repo, www.svgrepo.com, Generator: SVG Repo Mixer Tools  */}
                    <svg
                      width="100%"
                      height="auto"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <rect width={24} height={24} fill="white" />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M5 9.5C5 7.01472 7.01472 5 9.5 5C11.9853 5 14 7.01472 14 9.5C14 11.9853 11.9853 14 9.5 14C7.01472 14 5 11.9853 5 9.5Z"
                        fill="currentColor"
                      />
                      <path
                        d="M14.3675 12.0632C14.322 12.1494 14.3413 12.2569 14.4196 12.3149C15.0012 12.7454 15.7209 13 16.5 13C18.433 13 20 11.433 20 9.5C20 7.567 18.433 6 16.5 6C15.7209 6 15.0012 6.2546 14.4196 6.68513C14.3413 6.74313 14.322 6.85058 14.3675 6.93679C14.7714 7.70219 15 8.5744 15 9.5C15 10.4256 14.7714 11.2978 14.3675 12.0632Z"
                        fill="currentColor"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M4.64115 15.6993C5.87351 15.1644 7.49045 15 9.49995 15C11.5112 15 13.1293 15.1647 14.3621 15.7008C15.705 16.2847 16.5212 17.2793 16.949 18.6836C17.1495 19.3418 16.6551 20 15.9738 20H3.02801C2.34589 20 1.85045 19.3408 2.05157 18.6814C2.47994 17.2769 3.29738 16.2826 4.64115 15.6993Z"
                        fill="currentColor"
                      />
                      <path
                        d="M14.8185 14.0364C14.4045 14.0621 14.3802 14.6183 14.7606 14.7837V14.7837C15.803 15.237 16.5879 15.9043 17.1508 16.756C17.6127 17.4549 18.33 18 19.1677 18H20.9483C21.6555 18 22.1715 17.2973 21.9227 16.6108C21.9084 16.5713 21.8935 16.5321 21.8781 16.4932C21.5357 15.6286 20.9488 14.9921 20.0798 14.5864C19.2639 14.2055 18.2425 14.0483 17.0392 14.0008L17.0194 14H16.9997C16.2909 14 15.5506 13.9909 14.8185 14.0364Z"
                        fill="currentColor"
                      />
                    </svg>
                  </div>

                  {userProfile?.reviews_count ? (
                    <div className="review-text-increase">
                      {userProfile?.reviews_count} ·{" "}
                    </div>
                  ) : null}
                  {userProfile?.table_count > 0 ? (
                    <a href="#" className="review-link">
                      &nbsp; &nbsp;{userProfile?.table_count} Tables Hosted
                    </a>
                  ) : (
                    <div className="review-text-increase">No Table Hosted</div>
                  )}
                </div>
              </div>
              <div className="margin-top margin-medium w-72 dfkex">
                {userProfile?.about_me ? (
                  <p className="text-gray-800 paragra2 w-72 break-words overflow-hidden">
                    {userProfile?.about_me}
                  </p>
                ) : (
                  <p className="paragraph-2">
                    No description? No problem, just vibes.
                  </p>
                )}
              </div>
              <div className="margin-top margin-medium">
                {interestNames.length > 0 ? (
                  <div className="flex flex-wrap gap-2 mt-4">
                    {interestNames.map((interest, index) => (
                      <span
                        key={index}
                        className="px-4 py-2 text-sm font-medium text-gray-700 border border-gray-300 rounded-full bg-white hover:bg-gray-100"
                      >
                        {interest}
                      </span>
                    ))}
                  </div>
                ) : (
                  <p className="text-gray-500 mt-4 text-sm">
                    No interests selected, just vibing. ✌️
                  </p>
                )}
              </div>

              <div className="social-icon-flex">
                {userProfile?.instagram_link && (
                  <Link
                    to={`https://www.instagram.com/${userProfile?.instagram_link}`}
                    className="social-icon w-embed"
                    target="_blank" // Opens the link in a new tab
                    rel="noopener noreferrer" // Improves security
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      x="0px"
                      y="0px"
                      width="100%"
                      height="100%"
                      viewBox="0 0 48 48"
                    >
                      <radialGradient
                        id="yOrnnhliCrdS2gy~4tD8ma_Xy10Jcu1L2Su_gr1"
                        cx="19.38"
                        cy="42.035"
                        r="44.899"
                        gradientUnits="userSpaceOnUse"
                      >
                        <stop offset={0} stopColor="#fd5" />
                        <stop offset=".328" stopColor="#ff543f" />
                        <stop offset=".348" stopColor="#fc5245" />
                        <stop offset=".504" stopColor="#e64771" />
                        <stop offset=".643" stopColor="#d53e91" />
                        <stop offset=".761" stopColor="#cc39a4" />
                        <stop offset=".841" stopColor="#c837ab" />
                      </radialGradient>
                      <path
                        fill="url(#yOrnnhliCrdS2gy~4tD8ma_Xy10Jcu1L2Su_gr1)"
                        d="M34.017,41.99l-20,0.019c-4.4,0.004-8.003-3.592-8.008-7.992l-0.019-20	c-0.004-4.4,3.592-8.003,7.992-8.008l20-0.019c4.4-0.004,8.003,3.592,8.008,7.992l0.019,20	C42.014,38.383,38.417,41.986,34.017,41.99z"
                      />
                      <radialGradient
                        id="yOrnnhliCrdS2gy~4tD8mb_Xy10Jcu1L2Su_gr2"
                        cx="11.786"
                        cy="5.54"
                        r="29.813"
                        gradientTransform="matrix(1 0 0 .6663 0 1.849)"
                        gradientUnits="userSpaceOnUse"
                      >
                        <stop offset={0} stopColor="#4168c9" />
                        <stop
                          offset=".999"
                          stopColor="#4168c9"
                          stopOpacity={0}
                        />
                      </radialGradient>
                      <path
                        fill="url(#yOrnnhliCrdS2gy~4tD8mb_Xy10Jcu1L2Su_gr2)"
                        d="M34.017,41.99l-20,0.019c-4.4,0.004-8.003-3.592-8.008-7.992l-0.019-20	c-0.004-4.4,3.592-8.003,7.992-8.008l20-0.019c4.4-0.004,8.003,3.592,8.008,7.992l0.019,20	C42.014,38.383,38.417,41.986,34.017,41.99z"
                      />
                      <path
                        fill="#fff"
                        d="M24,31c-3.859,0-7-3.14-7-7s3.141-7,7-7s7,3.14,7,7S27.859,31,24,31z M24,19c-2.757,0-5,2.243-5,5	s2.243,5,5,5s5-2.243,5-5S26.757,19,24,19z"
                      />
                      <circle cx="31.5" cy="16.5" r="1.5" fill="#fff" />
                      <path
                        fill="#fff"
                        d="M30,37H18c-3.859,0-7-3.14-7-7V18c0-3.86,3.141-7,7-7h12c3.859,0,7,3.14,7,7v12	C37,33.86,33.859,37,30,37z M18,13c-2.757,0-5,2.243-5,5v12c0,2.757,2.243,5,5,5h12c2.757,0,5-2.243,5-5V18c0-2.757-2.243-5-5-5H18z"
                      />
                    </svg>
                  </Link>
                )}
                {userProfile?.linkedin_link && (
                  <Link
                    to={`https://www.linkedin.com/in/${userProfile?.linkedin_link}`}
                    className="social-icon w-embed"
                    target="_blank" // Opens the link in a new tab
                    rel="noopener noreferrer" // Improves security
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      x="0px"
                      y="0px"
                      width="100%"
                      height="100%"
                      viewBox="0 0 48 48"
                    >
                      <path
                        fill="#0288D1"
                        d="M42,37c0,2.762-2.238,5-5,5H11c-2.761,0-5-2.238-5-5V11c0-2.762,2.239-5,5-5h26c2.762,0,5,2.238,5,5V37z"
                      />
                      <path
                        fill="#FFF"
                        d="M12 19H17V36H12zM14.485 17h-.028C12.965 17 12 15.888 12 14.499 12 13.08 12.995 12 14.514 12c1.521 0 2.458 1.08 2.486 2.499C17 15.887 16.035 17 14.485 17zM36 36h-5v-9.099c0-2.198-1.225-3.698-3.192-3.698-1.501 0-2.313 1.012-2.707 1.99C24.957 25.543 25 26.511 25 27v9h-5V19h5v2.616C25.721 20.5 26.85 19 29.738 19c3.578 0 6.261 2.25 6.261 7.274L36 36 36 36z"
                      />
                    </svg>
                  </Link>
                )}
                {userProfile?.facebook_id && (
                  <div className="social-icon w-embed">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      x="0px"
                      y="0px"
                      width="100%"
                      height="100%"
                      viewBox="0 0 48 48"
                    >
                      <path
                        fill="#3F51B5"
                        d="M42,37c0,2.762-2.238,5-5,5H11c-2.761,0-5-2.238-5-5V11c0-2.762,2.239-5,5-5h26c2.762,0,5,2.238,5,5V37z"
                      />
                      <path
                        fill="#FFF"
                        d="M34.368,25H31v13h-5V25h-3v-4h3v-2.41c0.002-3.508,1.459-5.59,5.592-5.59H35v4h-2.287C31.104,17,31,17.6,31,18.723V21h4L34.368,25z"
                      />
                    </svg>
                  </div>
                )}

                {userProfile?.x_link && (
                  <Link
                    to={`https://x.com/${userProfile?.x_link}`}
                    className="social-icon w-embed"
                    target="_blank" // Opens the link in a new tab
                    rel="noopener noreferrer" // Improves security
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      x="0px"
                      y="0px"
                      width="100%"
                      height="100%"
                      viewBox="0 0 30 30"
                    >
                      <path d="M 6 4 C 4.895 4 4 4.895 4 6 L 4 24 C 4 25.105 4.895 26 6 26 L 24 26 C 25.105 26 26 25.105 26 24 L 26 6 C 26 4.895 25.105 4 24 4 L 6 4 z M 8.6484375 9 L 13.259766 9 L 15.951172 12.847656 L 19.28125 9 L 20.732422 9 L 16.603516 13.78125 L 21.654297 21 L 17.042969 21 L 14.056641 16.730469 L 10.369141 21 L 8.8945312 21 L 13.400391 15.794922 L 8.6484375 9 z M 10.878906 10.183594 L 17.632812 19.810547 L 19.421875 19.810547 L 12.666016 10.183594 L 10.878906 10.183594 z" />
                    </svg>
                  </Link>
                )}
              </div>
              <div className="margin-bottom margin-small view-profile-btn pt-[30px]">
                <a
                  onClick={() => setEditProfileCliked(true)}
                  href="#"
                  className="button-3 w-button"
                >
                  Edit Profile
                </a>
              </div>
            </div>
          </div>
        </div>

        {editProfileClicked ? (
          <div
            id="w-node-d5ba6a23-980e-f379-d4e9-02ca982da006-27b28b52"
            data-current="Tab 1"
            data-easing="ease"
            data-duration-in={300}
            data-duration-out={100}
            className="profile-card-tabs w-tabs"
          >
            <ProfileEdit
              userProfile={userProfile}
              fetchProfileData={fetchProfileData}
            />
          </div>
        ) : (
          <div
            id="w-node-d5ba6a23-980e-f379-d4e9-02ca982da006-27b28b52"
            data-current="Tab 1"
            data-easing="ease"
            data-duration-in={300}
            data-duration-out={100}
            className="profile-card-tabs w-tabs"
          >
            <div className="my-account-tabs w-tab-menu">
              <a
                onClick={() => setSelectedTab(0)}
                data-w-tab="Tab 1"
                className={`myaccount-tab-1 w-inline-block w-tab-link  ${
                  selectedTab === 0 ? `w--current` : ``
                }`}
              >
                <h4 className="my-account-tab-text-box">My Bookings</h4>
              </a>
              <a
                onClick={() => setSelectedTab(1)}
                data-w-tab="Tab 2"
                className={`my-account-tab-2 w-inline-block w-tab-link  ${
                  selectedTab === 1 ? `w--current` : ``
                }`}
              >
                <h4 className="my-account-tab-text-box">My Tables</h4>
              </a>
            </div>

            <div className="my-account-tab-content-wrapper w-tab-content">
              {selectedTab === 0 ? (
                <Bookings
                  otherProfile={false}
                  userId={userProfile?.id}
                  bookings={true}
                />
              ) : (
                <div data-w-tab="Tab 2">
                  <Bookings
                    otherProfile={false}
                    userId={userProfile?.id}
                    bookings={false}
                  />
                </div>
              )}
            </div>
          </div>
        )}
      </div>
    </section>
  );
};

export default ProfilePageContent;
